import React from 'react';

import { BasicDrawRecord } from 'Api/SiteApi/Responses';

type Props = Readonly<{
    draws: BasicDrawRecord[];
    selectedDrawNo: number;
    onSelectDraw: (drawNo: number) => void;
}>;

function DropdownHours({ draws, selectedDrawNo, onSelectDraw }: Props) {
    return (
        <div className="dropdown mt-1">
            <select
                name="draw-hour"
                className="form-control"
                autoComplete="off"
                value={selectedDrawNo}
                id="datapicker-draw-hour"
                onChange={(event) => onSelectDraw(parseInt(event.target.value) || 0)}
            >
                {draws.map((draw) => (
                    <option key={draw.draw_no} value={draw.draw_no}>
                        {draw.date}
                    </option>
                ))}
            </select>
        </div>
    );
}

export default DropdownHours;
